export type LayoutIndentOverlayRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

type GetLayoutIndentOverlayRectsParams = {
  // Lowercased name of the focused object-form field.
  field: string;
  width: number;
  height: number;
  hIndent: number;
  vIndent: number;
};

// Strips visualizing the caption indent zone of a button while its form field
// holds focus (DevTools padding-overlay style): buttonhindent → left + right
// strips, buttonvindent → top + bottom strips, any other field → nothing.
export const getLayoutIndentOverlayRects = ({
  field,
  width,
  height,
  hIndent,
  vIndent,
}: GetLayoutIndentOverlayRectsParams): LayoutIndentOverlayRect[] => {
  if (field === 'buttonhindent') {
    const strip = Math.min(hIndent, width / 2);

    if (strip <= 0) {
      return [];
    }

    return [
      { x: 0, y: 0, width: strip, height },
      { x: width - strip, y: 0, width: strip, height },
    ];
  }

  if (field === 'buttonvindent') {
    const strip = Math.min(vIndent, height / 2);

    if (strip <= 0) {
      return [];
    }

    return [
      { x: 0, y: 0, width, height: strip },
      { x: 0, y: height - strip, width, height: strip },
    ];
  }

  return [];
};
